<div class="container">
  <div class="row">
    <mat-card class="col mat-elevation-z0">
      <h4 class="h1 text-center">IKTVA Saudi Community</h4>
      <mat-card-content>
        <p style="font-size:large" class="text-justify">
          At Halliburton, we collaborate and engineer solutions to maximize asset value for our customers.
          The IKTVA program is part of Saudi Vision 2030 launched in 2015 to drive domestic economic growth and sustainability in Saudi Arabia.
          This website was launched to provide a forum for collaboration with Halliburton’s Supply Chain Business Partners in gaining mutual advantage and achieving the Kingdom’s 2030 Vision.
        </p>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="row">
    <mat-card class="col mt-3 mat-elevation-z0" style="background-image: url('/assets/hal-chart.jpg');background-size:cover">
      <img mat-card-image src="/assets/hal-chart.jpg" />
    </mat-card>
  </div>  
</div>
